export default "__VITE_ASSET__BIZh4FaE__"